import { Box, Button, Divider, Fab, Typography } from '@mui/material'
import React from 'react'
import { format, parseISO } from 'date-fns'
import Assets from '../Common/Assets'
import { useNavigate } from 'react-router-dom'
import { useCommonStyles } from '../../utils'

const Notifications = ({ notificationData, setIsOpenNotification }) => {
    const { classes } = useCommonStyles();
    const navigate = useNavigate()

    const formatDate = (dateString) => {
        const date = parseISO(dateString);
        return format(date, "EEEE 'at' h:mm a");
    };
    const list = notificationData?.response || [];
    return (
        <Box>
            <Box padding={"25px"} display={"flex"} flexDirection={"column"} gap={2} height={'75vh'} overflow={"auto"}>
                {list.length === 0 ? (
                    <Typography textAlign="center" color="#A5ACB8" mt={4}>No notifications</Typography>
                ) : list.map((ele, idx) => (
                        <React.Fragment key={ele?._id || idx}>
                            <Box display={"flex"} justifyContent={"space-between"} alignItems={"start"} gap={5}>
                                <Box display={"flex"} gap={2} alignItems={"start"} >
                                    <Fab sx={{ boxShadow: "none", backgroundColor: "#F5F9FB", height: "48px", width: "48px" }} aria-label="Notification">
                                        <Assets absolutePath={true} src={`/assets/img/Notification.svg`} />
                                    </Fab>
                                    <Box>
                                        <Typography color={"#1A1F36"} fontSize={'14px'} fontFamily={"Satoshi-Medium"}>{ele?.subTitle}</Typography>
                                        <Box maxHeight={"50px"} overflow={"auto"}
                                            sx={{
                                                textAlign: "left",
                                                paddingLeft: "10px",
                                                marginTop: "10px",
                                            }}
                                        >
                                            <Typography color={"#1A1F36"} fontSize={'14px'} fontFamily={"Satoshi-Medium"}>
                                                {ele?.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Typography color={"#A5ACB8"} fontSize={'12px'} whiteSpace={'nowrap'} fontFamily={"Satoshi-Light"}>
                                    {ele?.dateAndTime ? formatDate(ele?.dateAndTime) : ""}
                                </Typography>
                            </Box>
                            <Divider />
                        </React.Fragment>
                ))}
            </Box>
            <Box paddingX={"25px"} textAlign={"end"}>
                <Button className={classes.saveButton} onClick={() => { setIsOpenNotification(false); navigate('/notification') }}>View All</Button>

            </Box>
        </Box>
    )
}

export default Notifications
